import cx from 'classnames'

export function SectionTitle({ children }: { children: React.ReactNode }) {
  return <h2 className="font-bold text-lg">{children}</h2>
}

export function SubSectionTitle({ children }: { children: React.ReactNode }) {
  return <h3 className="text-text-secondary">{children}</h3>
}

export const BodyTd = ({
  children,
  isNumeric = false,
  className
}: {
  children: React.ReactNode
  isNumeric?: boolean
  className?: string
}) => (
  <td
    className={cx(
      'py-1.5 px-3',
      className,
      'first:border-l first:border-l-text-disabled first:font-semibold',
      'last:border-r last:border-r-text-disabled',
      {
        ' text-right': isNumeric
      }
    )}
  >
    {children}
  </td>
)

export const FooterTd = ({
  children,
  isNumeric = false
}: {
  children: React.ReactNode
  isNumeric?: boolean
}) => (
  <td
    className={cx('py-1.5 px-3 border-t border-t-green-500 border-x-text-disabled font-semibold', {
      ' text-right': isNumeric
    })}
  >
    {children}
  </td>
)

export const HeaderTh = ({
  children,
  isNumeric = false,
  className
}: {
  children?: React.ReactNode
  isNumeric?: boolean
  className?: string
}) => (
  <th
    className={cx('py-1.5 px-3 font-semibold', className, {
      'text-right': isNumeric
    })}
  >
    {children}
  </th>
)

export const TableBodyRow = ({ children }: { children: React.ReactNode }) => (
  <tr className="even:bg-background-main">{children}</tr>
)

export const TableBody = ({ children }: { children: React.ReactNode }) => (
  <tbody className="border-x-text-disabled border-t border-t-green-500 border-b border-b-green-500">
    {children}
  </tbody>
)
